/* Magic Star: Google Ads WhatsApp click measurement. */
(() => {
  if (window.magicStarAds) return;
  const tagId = 'AW-986910086';
  const destination = 'AW-986910086/vvG7CIKfhp0dEIabzNYD';
  let configured = false;
  function allowed() {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!privacy && privacy.marketingAllowed() && privacy.analyticsProcessingAllowed();
    } catch (_) { return false; }
  }
  function sync() {
    if (window.Shopify && window.Shopify.designMode) return;
    if (!allowed()) {
      if (configured && typeof window.gtag === 'function') {
        window.gtag('consent', 'update', {ad_storage:'denied',analytics_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
      }
      return;
    }
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('consent', 'update', {ad_storage:'granted',analytics_storage:'granted',ad_user_data:'granted',ad_personalization:'denied'});
    if (configured) return;
    configured = true;
    window.gtag('js', new Date());
    window.gtag('config', tagId, {allow_ad_personalization_signals:false});
    if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + tagId;
      document.head.appendChild(script);
    }
  }
  function track(done) {
    let finished = false;
    const finish = () => { if (!finished) { finished = true; if (done) done(); } };
    try {
      if (!allowed() || !configured || (window.Shopify && window.Shopify.designMode)) { finish(); return; }
      if (done) setTimeout(finish, 800);
      window.gtag('event', 'conversion', {
        send_to: destination,
        event_callback: finish,
        event_timeout: 700
      });
    } catch (_) { finish(); }
  }
  window.magicStarAds = {track};
  document.addEventListener('click', event => {
    const link = event.target.closest && event.target.closest('[data-magic-star-garden] a[href]');
    if (!link || event.defaultPrevented) return;
    try {
      const url = new URL(link.href, window.location.href);
      const garden = link.closest('[data-magic-star-garden]');
      const phone = (garden.dataset.phone || '').replace(/\D/g, '');
      if (url.hostname !== 'wa.me' || url.pathname.replace(/\//g, '') !== phone) return;
      if (!phone) return;
      // Preserve native new-tab, modifier-key and mobile behavior.
      track();
    } catch (_) { /* Navigation always remains available. */ }
  });
  document.addEventListener('visitorConsentCollected', sync);
  function init() {
    if (window.Shopify && window.Shopify.customerPrivacy) { sync(); return; }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => { if (!error) sync(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
